import React from 'react';
import {StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';
import { Alert } from 'react-bootstrap';
import '../../sass/style.scss';
import '../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

class AlertPanel extends React.Component {
  constructor(props) {
    super(props);
    this.checkPrivate = this.checkPrivate.bind(this);
    this.state = { statusResponse: 0 };
  }


  async checkPrivate(e, espnId, url) {
    e.preventDefault();
    const url2020 = `https://fantasy.espn.com/apis/v3/games/ffl/seasons/2021/segments/0/leagues/${espnId}?view=mSetting`;
    const status = await fetch(url2020)
      .then(response => { return response.status })
      .catch(error => {
        console.log(error);
      });
    if (status === 200) {
      window.open(url);
      this.setState({ statusResponse: status });
    }
    else {
      this.setState({ statusResponse: status });
    }
  }

  render() {
    const paid = this.props.paid;

    if (!paid) {
      return <Alert key="1" variant="info">
        <Alert.Heading>Site won't update automatically</Alert.Heading>
        <Alert.Heading> Join Patreon or Donate* to enable updates.</Alert.Heading>
        <p>Creating each site and updating them is a manual process that takes time, if you're enjoying the site please reconsider and make a donation.</p>
        <p>After donating I will also remove this alert along with all mentioned of support the site etc.</p>
        <p>If you already donated and this message still is showing up contact me and I will fix it ASAP.</p>
        <img className="mr-2" src="https://www.zellepay.com/sites/default/files/zelle%20logo%20card_0.jpg" width="100" alt="Zelle" /> fabianbrenes [at] gmail [dot] com
        <a className="bmc-button my-3" target="_blank" rel="noopener noreferrer" href="https://www.paypal.com/paypalme2/FabianBrenes">
          <img className="mr-2" src="https://www.paypalobjects.com/webstatic/icon/pp258.png" width="40" alt="Paypal.me" />
          <span>Paypal Me</span>
        </a>
        <a className="bmc-button my-3" target="_blank" rel="noopener noreferrer" href="https://www.patreon.com/bePatron?u=13567542" data-patreon-widget-type="become-patron-button">
          <img className="mr-2" src="https://fantasy-franchise.com/img/patreon.jpg" width="40" alt="Patreon" />
          <span>Become a Patron!</span>
        </a>
        * Depending on the amount of the donation yearly, monthly or weekly updates will be enabled.
       
      </Alert>;
    }
    else {
      return null;
    }
  }
}

function MessagePanel(props) {
  const status = props.status;
  if (status === 200) {
    return (
      <p className="text-info">Your request was succefully made</p>
    )
  }
  else if (status === 0) {
    return (
      <p>It seems that your league is private and therefore I can't get the 2021 data.
        Once you change it public click the following button to request an update. <br /> If you don't how to do that please follow <a target="_blank" rel="noopener noreferrer" href="https://support.espn.com/hc/en-us/articles/360000064451-Making-a-Private-League-Viewable-to-the-Public">this steps</a>.
        </p>
    )
  }
  else {
    return (
      <p className="text-danger">Your league still shows as private</p>
    )
  }
}

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.sidebarToggle = this.sidebarToggle.bind(this);
    this.state = {sidebarToggled: false};
    this.state = { status: 200 };
  }

  sidebarToggle = () => {
    const doesShow = this.state.sidebarToggled
    this.setState({ sidebarToggled: !doesShow })
  }
  render() {
    const { children} = this.props;
    return (
      <StaticQuery
        query={graphql`
          query {
            allSettingsJson {
              edges {
                node {
                  isPrivate
                  leagueName
                  paid
                  subscription
                }
              }
            }
          }
        `}
        render={data => (
          <div id="page-top" className={this.state.sidebarToggled ? 'sidebar-toggled' : 'sidebar-untoggled'}>
            <Helmet title="Fantasy Football Franchise Stats" />
            <Header triggerhappy={this.sidebarToggle} paid={data.allSettingsJson.edges[0].node.paid} leagueName={data.allSettingsJson.edges[0].node.leagueName}/>
            <div id="wrapper">
              <Sidebar toggled={this.state.sidebarToggled} paid={data.allSettingsJson.edges[0].node.paid}/>
              <div id="content-wrapper">
                <div className="container-fluid">
                  <AlertPanel paid={data.allSettingsJson.edges[0].node.paid} espnId={data.allSettingsJson.edges[0].node.id} />
                </div>
                {children}
              </div>
              <Footer />
            </div>
          </div>
        )}
      />
    )
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;

